export default {
  init() {
    // JavaScript to be fired on the home page
    //alert('homepage');
    $(document).ready(function () {
      var sectionSeen = false;
      var sectionSeen2 = false;
      $(window).scroll(function () {
        var section = $('#best-sellers');
        var section2 = $('#best-sellers');
        var offset = section.offset().top;
        var offset2 = section2.offset().top;
        var windowTop = $(window).scrollTop();

        if (windowTop + $(window).height() - 20 >= offset && !sectionSeen) {
          sectionSeen = true; // Marcar la bandera como true para evitar futuras ejecuciones
          $.ajax({
            type: 'POST',
            dataType: 'html', // Assuming the server returns JSON
            url: '/wp-admin/admin-ajax.php',
            data: {
              action: 'best_seller_ajax',
            },
            success: function (data) {
              $('#best-sellers .peek-slider').append(data); // Update element
              // recuperamos todas las imágenes e iframes con el atributo
              buildBestSliders();
            },
            error: function (jqXHR, textStatus, errorThrown) {
              console.error('AJAX Error:', textStatus, errorThrown); // Handle errors
            },
          });
          // La sección está a punto de entrar en la vista del usuario
          console.log('¡La sección está a punto de entrar en la vista del usuario!');
        }
        if (windowTop + $(window).height() - 20 >= offset2 && !sectionSeen2) {
          sectionSeen2 = true; // Marcar la bandera como true para evitar futuras ejecuciones
          $.ajax({
            type: 'POST',
            dataType: 'html', // Assuming the server returns JSON
            url: '/wp-admin/admin-ajax.php',
            data: {
              action: 'feat_deals_products_ajax',
            },
            success: function (data) {
              $('#deals .peek-slider').append(data); // Update element
              // recuperamos todas las imágenes e iframes con el atributo
              buildPeekSliders();
            },
            error: function (jqXHR, textStatus, errorThrown) {
              console.error('AJAX Error:', textStatus, errorThrown); // Handle errors
            },
          });
        }
      });
      function buildPeekSliders() {

        var $peekSlider = $('#deals .slider.peek-slider');
        if ($peekSlider.length) {
          $peekSlider.on('init', function (slick) {
            //If present, make the mobile .view-all slide the same height
            var sliderHeight = $(slick.target).height();
            var $viewAllSlide = $peekSlider.find('.view-all');
            if ($viewAllSlide.length !== 0) {
              $viewAllSlide.height(sliderHeight);
            }
          });
          var settings = {
            dots: false,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            centerMode: false,
            centerPadding: '60px',
            mobileFirst: true, //NEEDED FOR RESPONSIVE BREAKPOINTS TO WORK CORRECTLY
            responsive: [
              {
                breakpoint: 1024,
                settings: 'unslick',
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                },
              },
            ],
          }
        }
        $peekSlider.slick(settings);


        //Two visible items.
        var $peekSliderCompact = $('.slider.peek-slider-compact');
        if ($peekSliderCompact.length) {
          var settingsCompact = {
            dots: false,
            arrows: false,
            slidesToShow: 2,
            centerMode: false,
            centerPadding: '60px',
            mobileFirst: true, //NEEDED FOR RESPONSIVE BREAKPOINTS TO WORK CORRECTLY
            responsive: [
              {
                breakpoint: 1024,
                settings: 'unslick',
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                },
              },
            ],
          }
          $peekSliderCompact.slick(settingsCompact);
        }
      }

      function buildBestSliders() {

        var $peekSlider = $('#best-sellers .slider.peek-slider');
        if ($peekSlider.length) {
          $peekSlider.on('init', function (slick) {
            //If present, make the mobile .view-all slide the same height
            var sliderHeight = $(slick.target).height();
            var $viewAllSlide = $peekSlider.find('.view-all');
            if ($viewAllSlide.length !== 0) {
              $viewAllSlide.height(sliderHeight);
            }
          });
          var settings = {
            dots: false,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            centerMode: false,
            centerPadding: '60px',
            mobileFirst: true, //NEEDED FOR RESPONSIVE BREAKPOINTS TO WORK CORRECTLY
            responsive: [
              {
                breakpoint: 1024,
                settings: 'unslick',
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                },
              },
            ],
          }
        }
        $peekSlider.slick(settings);


        //Two visible items.
        var $peekSliderCompact = $('.slider.peek-slider-compact');
        if ($peekSliderCompact.length) {
          var settingsCompact = {
            dots: false,
            arrows: false,
            slidesToShow: 2,
            centerMode: false,
            centerPadding: '60px',
            mobileFirst: true, //NEEDED FOR RESPONSIVE BREAKPOINTS TO WORK CORRECTLY
            responsive: [
              {
                breakpoint: 1024,
                settings: 'unslick',
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                },
              },
            ],
          }
          $peekSliderCompact.slick(settingsCompact);
        }
      }
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js